import React from "react";
import { Box, TableContainer, Table, TableHead, TableRow, TableCell, TableBody, Paper, Link, IconButton, Tooltip } from "@mui/material";
import { Flag as FlagIcon } from "@mui/icons-material";
import { useSnackbar } from "notistack";

const ExpandedJobOffer = ({ data, isReadOnly, onFlagUpdate }) => {
  const { enqueueSnackbar } = useSnackbar();

  const logoMapping = {
    website: "/sander-logo.svg",
    indeed: "/static/images/logos/Indeed.svg",
    stepstone: "/static/images/logos/StepStone.svg"
  };

  const sortedApplications = (data.job_applications || []).sort(
    (a, b) => new Date(b.created_at) - new Date(a.created_at)
  );

  const handleFlagUpdate = (applicationId, newFlag) => {
    if (isReadOnly) {
      enqueueSnackbar("Flag changes must be made through the Dashboard of the user who posted the job offer.", {
        variant: "warning",
        autoHideDuration: 2000
      });
      return;
    }

    onFlagUpdate(applicationId, newFlag);
  };

  const getFlagColor = (flag) => {
    switch (flag) {
    case "good":
      return "#4caf50"; // green
    case "maybe":
      return "#ff9800"; // orange
    case "no_go":
      return "#f44336"; // red
    default:
      return "#9e9e9e"; // grey
    }
  };

  return (
    <Box sx={{ display: "flex", justifyContent: "center", width: "100%" }}>
      <TableContainer component={Paper} sx={{ marginTop: 2, marginBottom: 2, width: "90%" }}>
        <Table aria-label="job applications table">
          <TableHead>
            <TableRow>
              <TableCell sx={{ textAlign: "center", fontWeight: "bold" }}>Flag</TableCell>
              <TableCell sx={{ textAlign: "center", fontWeight: "bold" }}>Name</TableCell>
              <TableCell sx={{ textAlign: "center", fontWeight: "bold" }}>Email</TableCell>
              <TableCell sx={{ textAlign: "center", fontWeight: "bold" }}>Phone</TableCell>
              {/* <TableCell sx={{ textAlign: "center", fontWeight: "bold" }}>Message</TableCell> */}
              <TableCell sx={{ textAlign: "center", fontWeight: "bold" }}>Resume</TableCell>
              <TableCell sx={{ textAlign: "center", fontWeight: "bold" }}>Origin</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {sortedApplications.map((application, index) => {
              const candidate = application.candidate || {}; // Safeguard against missing candidate

              return (
                <TableRow key={index}>
                  <TableCell>
                    <Box sx={{ display: "flex", justifyContent: "center", gap: 1 }}>
                      <Tooltip title="Good">
                        <IconButton
                          size="small"
                          onClick={() => handleFlagUpdate(application.id, "good")}
                          sx={{
                            color: getFlagColor(application.flag === "good" ? "good" : "")
                          }}
                        >
                          <FlagIcon />
                        </IconButton>
                      </Tooltip>
                      <Tooltip title="Maybe">
                        <IconButton
                          size="small"
                          onClick={() => handleFlagUpdate(application.id, "maybe")}
                          sx={{
                            color: getFlagColor(application.flag === "maybe" ? "maybe" : "")
                          }}
                        >
                          <FlagIcon />
                        </IconButton>
                      </Tooltip>
                      <Tooltip title="No Go">
                        <IconButton
                          size="small"
                          onClick={() => handleFlagUpdate(application.id, "no_go")}
                          sx={{
                            color: getFlagColor(application.flag === "no_go" ? "no_go" : "")
                          }}
                        >
                          <FlagIcon />
                        </IconButton>
                      </Tooltip>
                    </Box>
                  </TableCell>
                  <TableCell sx={{ textAlign: "center" }}>
                    {candidate.name || <span style={{ color: "grey" }}>Not provided</span>}
                  </TableCell>
                  <TableCell sx={{ textAlign: "center" }}>
                    {candidate.email || <span style={{ color: "grey" }}>Not provided</span>}
                  </TableCell>
                  <TableCell sx={{ textAlign: "center" }}>
                    {candidate.phone || <span style={{ color: "grey" }}>Not provided</span>}
                  </TableCell>
                  {/* <TableCell sx={{ width: application.message ? "280px" : "inherit", textAlign: "center" }}>
                    {application.message ? (
                      application.message.length > 200
                        ? `${application.message.substring(0, 50)}...`
                        : application.message
                    ) : (
                      <span style={{ color: "grey" }}>No message included</span>
                    )}
                  </TableCell> */}
                  <TableCell sx={{ textAlign: "center" }}>
                    {application.resume_url ? (
                      <Link href={application.resume_url} target="_blank" color="primary" sx={{ cursor: "pointer" }}>
                        See CV
                      </Link>
                    ) : "No resume attached"}
                  </TableCell>
                  <TableCell>
                    <Box sx={{ display: "flex", justifyContent: "center", width: "100%" }}>
                      <img
                        src={logoMapping[application.origin] || "/sander-logo.svg"}
                        alt={application.origin || "Unknown"}
                        style={{ width: "80px", objectFit: "contain" }}
                      />
                    </Box>
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default ExpandedJobOffer;
